import { render, staticRenderFns } from "./UpdateOrderTypeDialog.vue?vue&type=template&id=de52104c&scoped=true&"
import script from "./UpdateOrderTypeDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de52104c",
  null
  
)

export default component.exports